import type { SVGProps } from "react";
export default function SvgCodeXml(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m18 16 4-4-4-4" />
			<path d="m6 8-4 4 4 4" />
			<path d="m14.5 4-5 16" />
		</svg>
	);
}
